import React from "react";
import TimeAgo from "react-timeago";

const CorrespondenceList = ({ items, onDownload }) => {
    if (items && items.length < 1)
        return (
            <div className="text-center text-pink">
                <i className="material-icons" style={{ fontSize: "4em" }}>
                    info
                </i>
                <br />
                <strong>No File has been added yet</strong>
            </div>
        );
    return (
        <table className="table table-bordered table-hover">
            <thead>
                <tr>
                    <th>SN</th>
                    <th>Name</th>
                    <th>Description</th>
                    <th>Date Created</th>
                    <th className="text-center">Download</th>
                </tr>
            </thead>
            <tbody>
                {items &&
                    items.map((item, index) => (
                        <tr key={index}>
                            <td className="inbox-small-cells">
                                <div className="todo-check pull-left">{index + 1}</div>
                            </td>
                            <td className="view-message">
                                <span>{item.name}</span>
                                <br />
                                <small className="text-muted">
                                    <TimeAgo date={item.created_at}></TimeAgo>
                                </small>
                            </td>
                            <td className="view-message">{item.desc}</td>
                            <td className="view-message">
                                {Intl.DateTimeFormat("en-GB", {
                                    month: "short",
                                    year: "numeric",
                                    weekday: "short",
                                    day: "numeric",
                                }).format(new Date(item.created_at))}
                            </td>

                            <td className="view-message text-center">
                                <button onClick={() => onDownload(item.fileUrl)} title="Download" className="mdl-button mdl-button--icon mdl-button--colored btn-default">
                                    <i className="material-icons text-success">cloud_download</i>
                                </button>
                            </td>
                        </tr>
                    ))}
            </tbody>
        </table>
    );
};

export default CorrespondenceList;
